import { connect } from 'react-redux';

import ActivateSubModal from './ActivateSubModal';
import { activateSub, findQuickSub } from 'actions/quickSubs';
import QuickActivateSubModalForm from './ActivateSubModalForm/quick';

import { getIncludedInGroups } from 'reducers';

const mapStateToProps = (state) => {
  return {
    isAgentOrAdminOrManager: getIncludedInGroups(state, [
      'ADMIN',
      'AGENT',
      'MANAGER',
    ]),
    ActivateSubModalForm: QuickActivateSubModalForm,
    successText: 'Activation Requested',
  };
};

const mapDispatchToProps = {
  findSub: findQuickSub,
  activateSub: activateSub,
};

const ActivateQuickSubModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActivateSubModal);

export default ActivateQuickSubModal;
